export default {"src":"/_next/static/media/import.480c59ab.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};